import { EntityRepository, Repository } from "typeorm";
import { PalletsController } from "./pallets.controller";
import { Pallet } from "./pallets.entity";

@EntityRepository(Pallet)
export class PalletsRepository extends Repository<Pallet>{

}
